import OrderBySwitch from './OrderBySwitch.component';

export default OrderBySwitch;
